import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {Spinner} from "react-bootstrap";
import IconButton from "../../../common/IconButton";
import {faCircleXmark} from "@fortawesome/free-solid-svg-icons";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {selectCurrentCertificate} from "../../../../app/store/reducers/eimzo/eimzoReducer";
import {cancelFreeFormDocumentAsync} from "../../../../app/store/reducers/roaming/roamingFreeFormDocumentReducer";
import SignActionWithSelectCertificatWrapper from "../../../hippo/roaming/components/SignActionWithSelectCertificatWrapper";

const CancelFreeFormDocument = ({id, ...props}) => {
    const [loading, setLoading] = useState(false);
    const currentCertificate = useSelector(selectCurrentCertificate);
    const lang = useSelector(selectLang);
    const t = Translate;

    const cancelFreeFormDocument = () => {
        setLoading(true);
        cancelFreeFormDocumentAsync({
            id: id,
            certificate: currentCertificate,
        })
            .finally(() => setLoading(false))
    }

    return (
        <>
            <SignActionWithSelectCertificatWrapper>
                <IconButton
                    size="sm"
                    {...props}
                    icon={faCircleXmark}
                    iconClassName="me-1"
                    variant="falcon-danger"
                    onClick={cancelFreeFormDocument}
                >
                    {t(lang, 'roaming.free_form_document.view.action.cancel')}
                    {loading && <Spinner className='align-middle ms-2' animation='border' role='switch' size='sm'/>}
                </IconButton>
            </SignActionWithSelectCertificatWrapper>
        </>
    );
};

export default CancelFreeFormDocument;